<div class="new-template-container">
  @if (!isTemplateSaved() || contractService.editTemplate()) {
    <div class="template-header d-flex jcsb">
      <div>
      <h1>Neue Vorlage erstellen</h1>
      <p class="subtitle">Erstellen Sie eine neue Dokumentvorlage</p>
      </div>
      @if (contractService.editTemplate()) {
        <div>
          <img src="phoenix-logo.png"/>
        </div>
      }
    </div>


    <mat-card class="template-form-card">
      <mat-card-content>
        <form [formGroup]="templateForm" (ngSubmit)="onTemplateSubmit()">

          <!-- Company Field -->
          <mat-form-field appearance="outline" >
            <mat-label>Firma</mat-label>
            <mat-select formControlName="company" name="company">
              @for (company of companies; track company) {
                <mat-option [value]="company.value">{{company.name}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <!-- Name Field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Vorlagenname</mat-label>
            <input
              matInput
              formControlName="name"
              placeholder="Geben Sie den Vorlagennamen ein"
              required>
            <mat-icon matPrefix fontSet="material-symbols-outlined">description</mat-icon>
            @if (templateForm.get('name')?.hasError('required') && templateForm.get('name')?.touched) {
              <mat-error>Vorlagenname ist erforderlich</mat-error>
            }
          </mat-form-field>

          <!-- Short Description Field -->
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Kurzbeschreibung</mat-label>
            <input
              matInput
              formControlName="shortDescription"
              placeholder="Geben Sie eine kurze Beschreibung ein"
              required>
            <mat-icon matPrefix fontSet="material-symbols-outlined">short_text</mat-icon>
            @if (templateForm.get('shortDescription')?.hasError('required') && templateForm.get('shortDescription')?.touched) {
              <mat-error>Kurzbeschreibung ist erforderlich</mat-error>
            }
          </mat-form-field>

          <!-- Action Buttons -->
          <div class="form-actions">
            <button
              mat-raised-button
              type="button"
              (click)="onCancel()"
              class="cancel-button">
              <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
              Abbrechen
            </button>

            <button
              mat-raised-button
              color="primary"
              type="submit"
              [disabled]="!templateForm.valid || isSubmitting()"
              class="submit-button">
              <mat-icon fontSet="material-symbols-outlined">send</mat-icon>
              @if (isSubmitting()) {
                <span>Wird gesendet...</span>
              } @else {
                <span>Weiter</span>
              }
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>

    @if(contractService.editTemplate()) {
      <app-page></app-page>
    }
  } @else {
    <!-- Template Saved - Page Editor View -->
    <div class="template-header d-flex jcsb">
      <div>
        <h1>{{templateForm.get('name')?.value}}</h1>
        <p class="subtitle">{{templateForm.get('shortDescription')?.value}}</p>
      </div>
      <div>
        <img src="phoenix-logo.png"/>
      </div>
    </div>

    <app-page></app-page>
  }
</div>
